export const getProvidersList = (list, previoulsyAddedProviders, areas) => {
  const dropdownList = [];
  if (list?.length) {
    list.forEach(item => {
      const { BranchKey, EntityAddressModel, ParentModel, NameEnglish } = item;
      const { Logo } = ParentModel;
      const { AreaKey } = EntityAddressModel;
      const providerArea = areas?.find(area => area.key === AreaKey);
      const providerNameDisplayed = `${NameEnglish} - ${providerArea?.name}`;
      const isPreviouslyAdded =
        previoulsyAddedProviders.findIndex(
          provider => provider?.provider?.providerKey === BranchKey,
        ) !== -1;

      const previouslyAddedProvider = previoulsyAddedProviders.find(
        provider => provider?.provider?.providerKey === BranchKey,
      );
      const isExclusive = previouslyAddedProvider?.exclusive || false;

      dropdownList.push({
        isSelected: isPreviouslyAdded,
        Name: providerNameDisplayed,
        itemImage: Logo,
        BranchKey,
        AreaKey,
        providerName: NameEnglish,
        parentEntityKey: ParentModel.EntityKey,
        isExclusive,
      });
    });
  }
  return dropdownList;
};

export const createQueryParam = (key, list) => {
  let query = '';
  list?.forEach(item => {
    if (!query) {
      query = `${key}=${item}`;
    } else {
      query = `${query}&${key}=${item}`;
    }
  });
  return query;
};
